import * as api from '../../api/api-carga-analytic'
import {  POST_CARGAR_ARCHIVO_ANALYTIC, GET_INFO_CARGA_ANALYTIC_PREVIO, GET_INFO_ERRORES_CARGA_ANALYTIC } from '../types'

export const cargarArchivoAction = (file) => ({
  type: POST_CARGAR_ARCHIVO_ANALYTIC,
  payload: api.postCargarArchivo(file)
})

export const getInfoCargaAnalyticPrevio = () => ({
  type: GET_INFO_CARGA_ANALYTIC_PREVIO,
  payload: api.serviceGetInformeAnalytic()
})

export const consultarInfoErroresCargaAnalytic = (query) => ({
  type: GET_INFO_ERRORES_CARGA_ANALYTIC,
  payload: api.getInfoErroresCargaAnalytic(query)
});